import type { NavigateOptions } from 'react-router-dom';
import { isSalesforceEmbedClient } from './embed-client-pure';

export {
  parseEmbedClient,
  getEmbedClientFromBrowser,
  isSalesforceEmbedClient,
  installSalesforceEmbedHistoryPushStatePatch,
  salesforceRedirectIfNeeded,
} from './embed-client-pure';

type CustomNavigateOptions = NavigateOptions & { clearExistingParams?: boolean };

export function mergeNavigateOptionsForSalesforceEmbed(
  navigateOptions?: CustomNavigateOptions
): CustomNavigateOptions | undefined {
  if (!isSalesforceEmbedClient()) {
    return navigateOptions;
  }
  if (navigateOptions?.replace !== undefined) {
    return navigateOptions;
  }
  return { ...navigateOptions, replace: true };
}
